export default "__VITE_ASSET__JThBzv5j__";